// @flow
import {
  getCurrentPathname,
  getQueryParam,
} from 'app/common/utils/RouterSelectors';

export const isOnSharedZapRoute = (state: Object) => {
  return getCurrentPathname(state).includes('/shared/');
};

export const isOnSharedZapPOC = (state: Object) => {
  return isOnSharedZapRoute(state) && !!getQueryParam(state, 'conv');
};
